import Breadcrumbs from "../components/Breadcrumbs";
import Button from "../components/form/controls/Button";
import Checkbox from "../components/form/controls/Checkbox";
import Date from "../components/form/controls/Date";
import Form from "../components/form/Form";
import FormGroup from "../components/form/FormGroup";
import BaseIcon from "../components/icons/BaseIcon";
import Input from "../components/form/controls/Input";
import FileUpload from "../components/form/controls/FileUpload";
import Loading from "../components/Loading";
import NumberInput from "../components/form/controls/NumberInput";
import PhoneInput from "../components/form/controls/PhoneInput";
import Radio from "../components/form/controls/Radio";
import RadioGroup from "../components/form/controls/RadioGroup";
import Select from "../components/form/controls/Select";
import Time from "../components/form/controls/Time";
import Results from "../components/results/Results";
import Tag from "../components/Tag";

export default {
  install: Vue => {
    Vue.component("ag-breadcrumbs", Breadcrumbs);
    Vue.component("ag-button", Button);
    Vue.component("ag-checkbox", Checkbox);
    Vue.component("ag-date", Date);
    Vue.component("ag-form", Form);
    Vue.component("ag-form-group", FormGroup);
    Vue.component("ag-icon", BaseIcon);
    Vue.component("ag-input", Input);
    Vue.component("ag-upload", FileUpload);
    Vue.component("ag-loading", Loading);
    Vue.component("ag-number", NumberInput);
    Vue.component("ag-phone", PhoneInput);
    Vue.component("ag-radio", Radio);
    Vue.component("ag-radio-group", RadioGroup);
    Vue.component("ag-select", Select);
    Vue.component("ag-time", Time);
    Vue.component("ag-results", Results);
    Vue.component("ag-tag", Tag);
  }
};
